import { motion, type Transition } from 'framer-motion';
import type { FC, ReactNode } from 'react';
import { cn } from 'src/utils/cn';

const layoutDuration = 0.1;

export const CardAnimation: FC<{ children: ReactNode }> = ({ children }) => (
  <motion.div
    layout
    transition={{ duration: layoutDuration, ease: 'easeInOut' }}
  >
    {children}
  </motion.div>
);

export const ContentAnimation: FC<{
  className?: string;
  children: ReactNode;
}> = ({ children, className }) => {
  const transition: Transition = { duration: 0.2, ease: 'easeInOut' };
  return (
    <motion.div
      className={cn('max-w-full', className)}
      initial={{ opacity: 0, pointerEvents: 'none' }}
      animate={{
        opacity: 1,
        transitionEnd: {
          pointerEvents: 'initial',
        },
      }}
      exit={{
        opacity: 0,
        transition,
      }}
      transition={{ ...transition, delay: layoutDuration }}
    >
      {children}
    </motion.div>
  );
};
